import { useMutation } from "@tanstack/react-query";
import { createBroadcast } from "../api/createBroadcast";
import { BroadcastToCreate } from "../types";

type Params = {
  broadcast: BroadcastToCreate;
};

export const useCreateBroadcastQuery = () => {
  return useMutation({
    mutationFn: async ({ broadcast }: Params) => {
      return await createBroadcast(broadcast);
    },
    onError: (e) => console.error(e),
  });
};
